import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomePersonalFeed: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHomePersonalFeed"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2.8208L3 8.4458V21H7.02468C7.27552 18.4734 9.40731 16.5 12 16.5C14.5927 16.5 16.7245 18.4734 16.9753 21H21V8.4458L12 2.8208ZM12 9.75C10.6193 9.75 9.5 10.8693 9.5 12.25C9.5 13.6307 10.6193 14.75 12 14.75C13.3807 14.75 14.5 13.6307 14.5 12.25C14.5 10.8693 13.3807 9.75 12 9.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomePersonalFeed;
